export default __webpack_public_path__ + "static/iconjar2-9-8493fff07c89157f0fbcd8e036add121.mp4";